export function textArg(name: string, category?: string, description?: string): { [k: string]: any } {
  return stringArg('text', name, category, description);
}

export function colorArg(name: string, category?: string, description?: string): { [k: string]: any } {
  return stringArg('color', name, category, description);
}

export function dateArg(name: string, category?: string, description?: string): { [k: string]: any } {
  return stringArg('date', name, category, description);
}

export function stringArg(controlType: 'text' | 'color' | 'date', name: string, category?: string, description?: string): { [k: string]: any } {
  const arg = {};
  arg[name] = {
    name: name,
    type: 'text',
    description: description,
    control: {
      type: controlType,
    },
    table: {
      category: category,
    },
  };
  return arg;
}

export function numberArg(name: string, category?: string, description?: string, options?: { min: number; max: number; step: number }, useSlider?: boolean): { [k: string]: any } {
  const arg = {};
  arg[name] = {
    name: name,
    type: 'number',
    description: description,

    control: {
      type: useSlider ? 'range' : 'number',
      ...options,
    },
    table: {
      category: category,
    },
  };
  return arg;
}

export function rangeArg(name: string, category?: string, description?: string, options?: { min: number; max: number; step: number }): { [k: string]: any } {
  return numberArg(name, category, description, options, true);
}

export function radioArg(name: string, options: { [name: string]: string }, category?: string, description?: string, inline = true): { [k: string]: any } {
  return enumArg(inline ? 'inline-radio' : 'radio', name, options, category, description);
}

export function selectArg(name: string, options: { [name: string]: string }, category?: string, description?: string): { [k: string]: any } {
  return enumArg('select', name, options, category, description);
}

export function multiSelectArg(name: string, options: { [name: string]: string }, category?: string, description?: string): { [k: string]: any } {
  return enumArg('multi-select', name, options, category, description);
}

export function checkArg(name: string, options: { [name: string]: string }, category?: string, description?: string, inline = true): { [k: string]: any } {
  return enumArg(inline ? 'inline-check' : 'check', name, options, category, description);
}

export function enumArg(
  controlType: 'radio' | 'inline-radio' | 'check' | 'inline-check' | 'select' | 'multi-select',
  name: string,
  options: { [name: string]: string },
  category?: string,
  description?: string,
): { [k: string]: any } {
  const arg = {};
  arg[name] = {
    options: Object.keys(options),
    name: name,
    type: 'text',
    description: description,
    control: {
      type: controlType,
      labels: options,
    },
    table: {
      category: category,
    },
  };
  return arg;
}

export function boolArg(name: string, category?: string, description?: string): { [k: string]: any } {
  const arg = {};
  arg[name] = {
    name: name,
    description: description,
    control: {
      type: 'boolean',
    },
    table: {
      category: category,
    },
  };
  return arg;
}

export function objectArg(name: string, category?: string, description?: string): { [k: string]: any } {
  const arg = {};
  arg[name] = {
    name: name,
    description: description,
    control: {
      type: 'object',
    },
    table: {
      category: category,
    },
  };
  return arg;
}

export function setProps(selector: string, props: any, timeout = 0) {
  setTimeout(() => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      Object.keys(props).forEach(key => {
        element[key] = props[key];
      });
    });
  }, timeout);
}

export function objectToAttrs(obj) {
  if (!obj) return '';
  return Object.keys(obj)
    .map(k => {
      return `${k}='${obj[k]}'`;
    })
    .join(' ');
}

export function hideArgs(argsNames: string[]) {
  return argsNames.reduce(
    (result, argName) => ({
      ...result,
      [argName]: { table: { disable: true } },
    }),
    {},
  );
}
